
import { mapGetters } from 'vuex'
export default {
	props: ["layout"],
	components: {
		dynamicComponentLoader  : () => import('../pages/dynamic-component-loader.vue')
	},
	computed: {
		...mapGetters({
			getterLogin		: 'getterLogin',
			getterCart		: 'getterCart'
		}),
		getItemsCart(){
			return this.getterCart?.details?.count || 0;
		}
	},
	methods: {
		openSidebarCart(event){
			event.preventDefault();
			this.$root.$emit('show-sidebar-cart', true);
		}
	}
}
